export default "__VITE_ASSET__CMkPdkuT__"